import { qrPublicApi } from "./axios";
import { ServiceResponseI } from "../../interfaces";
import {
  QrValidateResponseI,
  CheckClientByDocResponseI,
  QrClientSelectionI,
  RegisterQrAcFormI,
  RegisterQrEquipmentResponseI,
} from "../../interfaces";
import { AxiosError } from "axios";

// Estas llamadas son PÚBLICAS: sin token, sin LogoutSystem.
// El token del QR es el único "credencial" de esta ruta.

export const validateQrToken = async (
  token: string,
): Promise<ServiceResponseI<QrValidateResponseI>> => {
  try {
    const { data } = await qrPublicApi.get<
      ServiceResponseI<QrValidateResponseI>
    >(`/${token}`);
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    throw new Error((obj?.data as Error)?.message ?? (err as Error).message);
  }
};

export const checkClientByDoc = async (
  token: string,
  docRuc: string,
): Promise<ServiceResponseI<CheckClientByDocResponseI>> => {
  try {
    const { data } = await qrPublicApi.post<
      ServiceResponseI<CheckClientByDocResponseI>
    >(`/${token}/client`, { docRuc });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    throw new Error((obj?.data as Error)?.message ?? (err as Error).message);
  }
};

export const registerQrAc = async (
  token: string,
  clientSelection: QrClientSelectionI,
  equipment: RegisterQrAcFormI,
  typeEquipmentLocation: string,
): Promise<ServiceResponseI<RegisterQrEquipmentResponseI>> => {
  try {
    const payload = {
      ...equipment,
      typeEquipmentLocation,
      clientContactId: clientSelection.clientContactId,
      clientAddressId: clientSelection.clientAddressId,
      newClient: clientSelection.newClient,
    };

    const { data } = await qrPublicApi.post<
      ServiceResponseI<RegisterQrEquipmentResponseI>
    >(`/${token}/equipment/ac`, payload);
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    throw new Error((obj?.data as Error)?.message ?? (err as Error).message);
  }
};